import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import AlbumExperience from '../components/album/AlbumExperience';
import { useAuth } from '../auth/AuthProvider';
import { getAlbumBySlug } from '../config/albumCatalog';
import { hasUserAccessToSlug } from '../config/inviteAccess';

function AlbumPage() {
  const { slug } = useParams();
  const { user } = useAuth();
  const selectedProfile = sessionStorage.getItem('selectedProfile');
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!user) {
      setStatus('checking');
      return undefined;
    }

    let alive = true;
    const run = async () => {
      const localAlbumData = getAlbumBySlug(slug);
      if (!localAlbumData) {
        if (alive) setStatus('not-found');
        return;
      }

      const hasAccess = await hasUserAccessToSlug(user, slug);
      if (!alive) return;
      setStatus(hasAccess ? 'allowed' : 'forbidden');
    };

    run();
    return () => {
      alive = false;
    };
  }, [slug, user]);

  if (!user) {
    return <Navigate to="/login" replace state={{ from: `/v/${slug}` }} />;
  }

  if (status === 'checking') {
    return (
      <main style={{ minHeight: '100vh', background: '#000', color: '#fff', display: 'grid', placeItems: 'center' }}>
        <p>Checking your ticket...</p>
      </main>
    );
  }

  if (status === 'not-found') {
    return <Navigate to="/404" replace />;
  }

  if (status === 'forbidden') {
    return <Navigate to="/403" replace />;
  }

  if (selectedProfile !== slug) {
    return <Navigate to="/profiles" replace />;
  }

  const data = getAlbumBySlug(slug);
  if (!data) {
    return <Navigate to="/404" replace />;
  }

  return <AlbumExperience data={data} />;
}

export default AlbumPage;
